<template>
  <div class="container-wrapper">
    <div class="heading-wrapper">
      <img src="@/assets/embajadaros.svg" alt="" class="heading">
      <br>
      <svg width="301" height="21" viewBox="0 0 301 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 19C99.958 1.65814 200.005 1.66312 299.204 1.66312" stroke="#0092bc" stroke-width="3"
              stroke-linecap="round"/>
      </svg>
      <br>
      <p class="snippet">Contaremos con la presencia de uno de los mejores nombres del gaming del momento.<br></p>
    </div>
    <div class="content">
      <!--<div class="wrapper left">
          <img src="@/assets/img1.png" alt="" class="thumbnail">
          <h3 class="title">Lorem ipsum</h3>
          <div class="social-icons">
              <a href="" class="icon">
                  <svg width="62" height="49" viewBox="0 0 62 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M61.992 5.69652C59.7123 6.65916 57.2633 7.30959 54.6887 7.60358C57.3452 6.08884 59.3326 3.70481 60.2802 0.896342C57.7843 2.30905 55.0528 3.30344 52.2042 3.83629C50.2887 1.88725 47.7514 0.59539 44.9865 0.161287C42.2215 -0.272816 39.3834 0.175122 36.913 1.43556C34.4425 2.69599 32.4779 4.6984 31.324 7.1319C30.1702 9.5654 29.8917 12.2938 30.5319 14.8936C25.4747 14.6516 20.5274 13.399 16.0111 11.2171C11.4948 9.03521 7.51036 5.97272 4.31645 2.22842C3.22437 4.02361 2.59642 6.10499 2.59642 8.32166C2.59521 10.3172 3.11088 12.2821 4.0977 14.0422C5.08452 15.8022 6.51198 17.3029 8.2534 18.4111C6.23381 18.3499 4.25877 17.8299 2.49268 16.8943V17.0504C2.49247 19.8492 3.5084 22.5619 5.36808 24.7281C7.22776 26.8944 9.81664 28.3808 12.6954 28.9351C10.8219 29.4183 8.8577 29.4895 6.9511 29.1432C7.76333 31.5514 9.34547 33.6573 11.476 35.166C13.6066 36.6748 16.179 37.5109 18.8329 37.5572C14.3277 40.9275 8.76365 42.7557 3.03599 42.7477C2.02139 42.7479 1.00765 42.6915 0 42.5785C5.8139 46.1408 12.5817 48.0313 19.4937 48.0239C42.8915 48.0239 55.6825 29.5569 55.6825 13.5407C55.6825 13.0204 55.6688 12.4948 55.6443 11.9745C58.1323 10.2599 60.2799 8.13667 61.9865 5.70433L61.992 5.69652Z" fill="#0092bc"/>
                  </svg>
              </a>
              <a href="" class="icon">
                  <svg width="52" height="49" viewBox="0 0 52 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M25.8025 16.4983C21.1718 16.4983 17.3929 20.0995 17.3929 24.5122C17.3929 28.9249 21.1718 32.5261 25.8025 32.5261C30.4331 32.5261 34.2121 28.9249 34.2121 24.5122C34.2121 20.0995 30.4331 16.4983 25.8025 16.4983ZM51.025 24.5122C51.025 21.1936 51.0566 17.9051 50.861 14.5926C50.6654 10.7449 49.7443 7.33018 46.7918 4.51661C43.833 1.69703 40.2559 0.825302 36.2183 0.638933C32.7358 0.452564 29.2849 0.482623 25.8088 0.482623C22.3263 0.482623 18.8754 0.452564 15.3993 0.638933C11.3617 0.825302 7.77828 1.70304 4.82577 4.51661C1.86695 7.33619 0.952176 10.7449 0.756603 14.5926C0.561031 17.9111 0.592575 21.1996 0.592575 24.5122C0.592575 27.8248 0.561031 31.1193 0.756603 34.4318C0.952176 38.2795 1.87326 41.6942 4.82577 44.5078C7.78459 47.3274 11.3617 48.1991 15.3993 48.3855C18.8818 48.5718 22.3327 48.5418 25.8088 48.5418C29.2912 48.5418 32.7422 48.5718 36.2183 48.3855C40.2559 48.1991 43.8393 47.3214 46.7918 44.5078C49.7507 41.6882 50.6654 38.2795 50.861 34.4318C51.0629 31.1193 51.025 27.8308 51.025 24.5122ZM25.8025 36.8426C18.642 36.8426 12.8632 31.3357 12.8632 24.5122C12.8632 17.6887 18.642 12.1818 25.8025 12.1818C32.963 12.1818 38.7418 17.6887 38.7418 24.5122C38.7418 31.3357 32.963 36.8426 25.8025 36.8426ZM39.2718 14.5565C37.5999 14.5565 36.2498 13.2699 36.2498 11.6768C36.2498 10.0836 37.5999 8.79709 39.2718 8.79709C40.9436 8.79709 42.2937 10.0836 42.2937 11.6768C42.2942 12.0551 42.2163 12.4298 42.0646 12.7794C41.913 13.129 41.6904 13.4466 41.4097 13.7141C41.129 13.9816 40.7956 14.1937 40.4288 14.3383C40.0619 14.4828 39.6687 14.557 39.2718 14.5565Z" fill="#0092bc"/>
                  </svg>
              </a>
              <a href="" class="icon">
                  <svg width="66" height="42" viewBox="0 0 66 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M63.819 6.54286C63.4532 5.29939 62.7406 4.17361 61.7571 3.28521C60.7458 2.36949 59.5062 1.71445 58.1555 1.38192C53.1004 0.112207 32.8477 0.112207 32.8477 0.112207C24.4046 0.0206664 15.9635 0.423286 7.57217 1.31779C6.22142 1.67489 4.98422 2.34456 3.9706 3.26725C2.97466 4.18042 2.25327 5.30649 1.87642 6.54029C0.971169 11.1876 0.531334 15.9063 0.562849 20.6328C0.530548 25.3551 0.969303 30.0723 1.87642 34.7254C2.24519 35.9541 2.96389 37.075 3.96253 37.9805C4.96117 38.8859 6.20476 39.54 7.57217 39.8863C12.6946 41.1535 32.8477 41.1535 32.8477 41.1535C41.3016 41.2451 49.7534 40.8425 58.1555 39.9479C59.5062 39.6154 60.7458 38.9603 61.7571 38.0446C62.7403 37.1564 63.452 36.0304 63.8163 34.7869C64.7452 30.1415 65.1968 25.4208 65.1648 20.6918C65.2347 15.9429 64.7836 11.1999 63.819 6.54029V6.54286ZM26.409 29.4157V11.8526L43.2594 20.6354L26.409 29.4157Z" fill="#0092bc"/>
                  </svg>
              </a>
              <a href="" class="icon">
                  <svg width="45" height="49" viewBox="0 0 45 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.5355 0.807038C26.2531 0.766968 28.9551 0.790713 31.654 0.766968C31.8176 3.79598 32.9607 6.88138 35.2874 9.02291C37.6094 11.2179 40.8939 12.2226 44.0896 12.5624V20.5305C41.0948 20.437 38.086 19.8434 35.3684 18.6145C34.1848 18.104 33.0821 17.4466 32.0029 16.7743C31.9889 22.5563 32.0278 28.3308 31.964 34.0891C31.802 36.8554 30.8442 39.6084 29.156 41.8879C26.44 45.6827 21.7258 48.1567 16.8839 48.2338C13.914 48.3956 10.9473 47.6239 8.41653 46.2021C4.22254 43.8454 1.27132 39.5312 0.841487 34.9008C0.787344 33.9202 0.77903 32.9378 0.816569 31.9564C1.19034 28.1913 3.14484 24.5894 6.17859 22.1392C9.61726 19.2853 14.4342 17.9259 18.9443 18.7303C18.9864 21.6614 18.8634 24.5894 18.8634 27.5205C16.803 26.8853 14.3953 27.0634 12.595 28.2551C11.2778 29.082 10.2824 30.2986 9.7621 31.7175C9.33226 32.7207 9.4553 33.8353 9.48022 34.9008C9.9739 38.148 13.2506 40.8772 16.7485 40.5819C19.0674 40.5582 21.2897 39.2759 22.4983 37.3986C22.8892 36.7411 23.3268 36.0688 23.3501 35.2956C23.5542 31.7561 23.4732 28.2314 23.4981 24.6919C23.5152 16.7149 23.4732 8.76023 23.537 0.808522L23.5355 0.807038Z" fill="#0092bc"/>
                  </svg>
              </a>
              <a href="" class="icon">
                  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24.005 13.1533V25.5397H19.634V13.1533H24.005ZM36.0025 13.1533V25.5397H31.6315V13.1533H36.0025ZM36.0025 34.8438L43.629 27.5946V4.90527H7.63651V34.8438H17.4636V41.0369L24.005 34.8438H36.0025ZM48 0.766968V29.678L34.9173 42.0644H25.0902L18.5488 48.2576H12.0075V42.0644H0.00994873V9.01504L3.2957 0.766968H48Z" fill="#0092bc"/>
                  </svg>
              </a>
          </div>
      </div>-->
      <div class="wrapper">
        <img src="@/assets/img2.png" alt="" class="thumbnail">
        <h3 class="title">Xoan Ramos
        </h3>
        <div class="social-icons">
          <!--<a href="https://twitter.com/M0veMind" class="icon">
              <svg width="62" height="49" viewBox="0 0 62 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M61.992 5.69652C59.7123 6.65916 57.2633 7.30959 54.6887 7.60358C57.3452 6.08884 59.3326 3.70481 60.2802 0.896342C57.7843 2.30905 55.0528 3.30344 52.2042 3.83629C50.2887 1.88725 47.7514 0.59539 44.9865 0.161287C42.2215 -0.272816 39.3834 0.175122 36.913 1.43556C34.4425 2.69599 32.4779 4.6984 31.324 7.1319C30.1702 9.5654 29.8917 12.2938 30.5319 14.8936C25.4747 14.6516 20.5274 13.399 16.0111 11.2171C11.4948 9.03521 7.51036 5.97272 4.31645 2.22842C3.22437 4.02361 2.59642 6.10499 2.59642 8.32166C2.59521 10.3172 3.11088 12.2821 4.0977 14.0422C5.08452 15.8022 6.51198 17.3029 8.2534 18.4111C6.23381 18.3499 4.25877 17.8299 2.49268 16.8943V17.0504C2.49247 19.8492 3.5084 22.5619 5.36808 24.7281C7.22776 26.8944 9.81664 28.3808 12.6954 28.9351C10.8219 29.4183 8.8577 29.4895 6.9511 29.1432C7.76333 31.5514 9.34547 33.6573 11.476 35.166C13.6066 36.6748 16.179 37.5109 18.8329 37.5572C14.3277 40.9275 8.76365 42.7557 3.03599 42.7477C2.02139 42.7479 1.00765 42.6915 0 42.5785C5.8139 46.1408 12.5817 48.0313 19.4937 48.0239C42.8915 48.0239 55.6825 29.5569 55.6825 13.5407C55.6825 13.0204 55.6688 12.4948 55.6443 11.9745C58.1323 10.2599 60.2799 8.13667 61.9865 5.70433L61.992 5.69652Z" fill="#0092bc"/>
              </svg>
          </a>-->
          <a href="https://www.instagram.com/xoanramos_/?hl=es" class="icon">
            <svg width="52" height="49" viewBox="0 0 52 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M25.8025 16.4983C21.1718 16.4983 17.3929 20.0995 17.3929 24.5122C17.3929 28.9249 21.1718 32.5261 25.8025 32.5261C30.4331 32.5261 34.2121 28.9249 34.2121 24.5122C34.2121 20.0995 30.4331 16.4983 25.8025 16.4983ZM51.025 24.5122C51.025 21.1936 51.0566 17.9051 50.861 14.5926C50.6654 10.7449 49.7443 7.33018 46.7918 4.51661C43.833 1.69703 40.2559 0.825302 36.2183 0.638933C32.7358 0.452564 29.2849 0.482623 25.8088 0.482623C22.3263 0.482623 18.8754 0.452564 15.3993 0.638933C11.3617 0.825302 7.77828 1.70304 4.82577 4.51661C1.86695 7.33619 0.952176 10.7449 0.756603 14.5926C0.561031 17.9111 0.592575 21.1996 0.592575 24.5122C0.592575 27.8248 0.561031 31.1193 0.756603 34.4318C0.952176 38.2795 1.87326 41.6942 4.82577 44.5078C7.78459 47.3274 11.3617 48.1991 15.3993 48.3855C18.8818 48.5718 22.3327 48.5418 25.8088 48.5418C29.2912 48.5418 32.7422 48.5718 36.2183 48.3855C40.2559 48.1991 43.8393 47.3214 46.7918 44.5078C49.7507 41.6882 50.6654 38.2795 50.861 34.4318C51.0629 31.1193 51.025 27.8308 51.025 24.5122ZM25.8025 36.8426C18.642 36.8426 12.8632 31.3357 12.8632 24.5122C12.8632 17.6887 18.642 12.1818 25.8025 12.1818C32.963 12.1818 38.7418 17.6887 38.7418 24.5122C38.7418 31.3357 32.963 36.8426 25.8025 36.8426ZM39.2718 14.5565C37.5999 14.5565 36.2498 13.2699 36.2498 11.6768C36.2498 10.0836 37.5999 8.79709 39.2718 8.79709C40.9436 8.79709 42.2937 10.0836 42.2937 11.6768C42.2942 12.0551 42.2163 12.4298 42.0646 12.7794C41.913 13.129 41.6904 13.4466 41.4097 13.7141C41.129 13.9816 40.7956 14.1937 40.4288 14.3383C40.0619 14.4828 39.6687 14.557 39.2718 14.5565Z"
                  fill="#0092bc"/>
            </svg>
          </a>
          <a href="https://www.youtube.com/c/XoanRamos" class="icon">
            <svg width="66" height="42" viewBox="0 0 66 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M63.819 6.54286C63.4532 5.29939 62.7406 4.17361 61.7571 3.28521C60.7458 2.36949 59.5062 1.71445 58.1555 1.38192C53.1004 0.112207 32.8477 0.112207 32.8477 0.112207C24.4046 0.0206664 15.9635 0.423286 7.57217 1.31779C6.22142 1.67489 4.98422 2.34456 3.9706 3.26725C2.97466 4.18042 2.25327 5.30649 1.87642 6.54029C0.971169 11.1876 0.531334 15.9063 0.562849 20.6328C0.530548 25.3551 0.969303 30.0723 1.87642 34.7254C2.24519 35.9541 2.96389 37.075 3.96253 37.9805C4.96117 38.8859 6.20476 39.54 7.57217 39.8863C12.6946 41.1535 32.8477 41.1535 32.8477 41.1535C41.3016 41.2451 49.7534 40.8425 58.1555 39.9479C59.5062 39.6154 60.7458 38.9603 61.7571 38.0446C62.7403 37.1564 63.452 36.0304 63.8163 34.7869C64.7452 30.1415 65.1968 25.4208 65.1648 20.6918C65.2347 15.9429 64.7836 11.1999 63.819 6.54029V6.54286ZM26.409 29.4157V11.8526L43.2594 20.6354L26.409 29.4157Z"
                  fill="#0092bc"/>
            </svg>
          </a>
          <a href="https://www.tiktok.com/@xoanramos" class="icon">
            <svg width="45" height="49" viewBox="0 0 45 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M23.5355 0.807038C26.2531 0.766968 28.9551 0.790713 31.654 0.766968C31.8176 3.79598 32.9607 6.88138 35.2874 9.02291C37.6094 11.2179 40.8939 12.2226 44.0896 12.5624V20.5305C41.0948 20.437 38.086 19.8434 35.3684 18.6145C34.1848 18.104 33.0821 17.4466 32.0029 16.7743C31.9889 22.5563 32.0278 28.3308 31.964 34.0891C31.802 36.8554 30.8442 39.6084 29.156 41.8879C26.44 45.6827 21.7258 48.1567 16.8839 48.2338C13.914 48.3956 10.9473 47.6239 8.41653 46.2021C4.22254 43.8454 1.27132 39.5312 0.841487 34.9008C0.787344 33.9202 0.77903 32.9378 0.816569 31.9564C1.19034 28.1913 3.14484 24.5894 6.17859 22.1392C9.61726 19.2853 14.4342 17.9259 18.9443 18.7303C18.9864 21.6614 18.8634 24.5894 18.8634 27.5205C16.803 26.8853 14.3953 27.0634 12.595 28.2551C11.2778 29.082 10.2824 30.2986 9.7621 31.7175C9.33226 32.7207 9.4553 33.8353 9.48022 34.9008C9.9739 38.148 13.2506 40.8772 16.7485 40.5819C19.0674 40.5582 21.2897 39.2759 22.4983 37.3986C22.8892 36.7411 23.3268 36.0688 23.3501 35.2956C23.5542 31.7561 23.4732 28.2314 23.4981 24.6919C23.5152 16.7149 23.4732 8.76023 23.537 0.808522L23.5355 0.807038Z"
                  fill="#0092bc"/>
            </svg>
          </a>
          <!--<a href="https://www.twitch.tv/move_mind" class="icon">
              <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24.005 13.1533V25.5397H19.634V13.1533H24.005ZM36.0025 13.1533V25.5397H31.6315V13.1533H36.0025ZM36.0025 34.8438L43.629 27.5946V4.90527H7.63651V34.8438H17.4636V41.0369L24.005 34.8438H36.0025ZM48 0.766968V29.678L34.9173 42.0644H25.0902L18.5488 48.2576H12.0075V42.0644H0.00994873V9.01504L3.2957 0.766968H48Z" fill="#0092bc"/>
              </svg>
          </a>-->
        </div>
      </div>
    </div>
    <svg width="69" height="326" viewBox="0 0 69 326" fill="none" xmlns="http://www.w3.org/2000/svg" class="bg-line">
      <path
          d="M-53.4371 4.90416C-23.1213 23.9641 8.68561 39.6948 39.9045 57.103C45.0094 59.9496 58.1081 65.9552 58.6768 73.0073C59.5272 83.5518 39.7977 96.6176 33.5499 102.333C20.4275 114.336 7.60663 126.6 -4.14834 139.962C-9.8656 146.461 -23.925 159.998 -23.9645 170.146C-23.9911 176.996 -5.63377 169.821 -4.13716 169.383C9.78694 165.311 27.6348 158.268 42.3548 162.419C50.215 164.636 41.4821 172.094 39.5587 174.178C31.1902 183.25 20.9483 192.146 14.7416 202.919C10.8285 209.71 20.3857 209.739 24.7161 210.572C36.3889 212.818 47.8565 216.07 56.4378 224.842C83.4727 252.48 27.7267 295.47 62.4854 321.344"
          stroke="#0092bc" stroke-width="8" stroke-linecap="round"/>
    </svg>
    <img src="@/assets/bg-hexa.svg" alt="" class="bg-hexa">
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.container-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 90px 20px;
  @media only screen and (max-width: 780px) {
    padding: 50px 10px;
  }

  .heading-wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img.heading {
      @media only screen and (max-width: 580px) {
        max-width: 240px;
      }
    }

    .title {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 36px;
      line-height: 43px;
      text-align: center;
      color: #012A2D;
      @media only screen and (max-width: 680px) {
      }
    }

    .snippet {
      width: 100%;
      max-width: 830px;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 29px;
      text-align: center;
      color: #000000;
      margin-bottom: 30px;
      @media only screen and (max-width: 780px) {
        font-size: 18px;
        line-height: 22px;
      }
      @media only screen and (max-width: 580px) {
        font-size: 15px;
        line-height: 18px;
      }
    }

  }

  .content {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    z-index: 2;
    @media only screen and (max-width: 780px) {
      // flex-direction: columns;
    }

    & > *:not(:last-child) {
      margin-right: 150px;
      @media only screen and (max-width: 1040px) {
        margin-right: 30px;
      }
      @media only screen and (max-width: 580px) {
        margin-right: 10px;
      }
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .thumbnail {
        width: 370px;
        box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
        margin-bottom: 30px;
        @media only screen and (max-width: 1040px) {
          width: 280px;
        }
        @media only screen and (max-width: 780px) {
          margin-bottom: 10px;
          width: 200px;
        }
        @media only screen and (max-width: 580px) {
          width: 130px;
          margin-bottom: 10px;
        }
      }

      .title {
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: #000000;
        text-transform: capitalize;
        margin-bottom: 30px;
        @media only screen and (max-width: 780px) {
          margin-bottom: 15px;
          font-size: 24px;
          line-height: 28px;
        }
        @media only screen and (max-width: 580px) {
          margin-bottom: 10px;
          font-size: 18px;
          line-height: 22px;
        }

      }

      .social-icons {
        .icon {
          margin: 10px;
          @media only screen and (max-width: 580px) {
            margin: 5px;
          }

          svg {
            @media only screen and (max-width: 1040px) {
              min-width: 30px;
              min-height: 30px;
              width: 30px;
              height: 30px;
            }
            @media only screen and (max-width: 780px) {
              min-width: 20px;
              min-height: 20px;
              width: 20px;
              height: 20px;
            }
            @media only screen and (max-width: 580px) {
              min-width: 15px;
              min-height: 15px;
              width: 15px;
              height: 15px;
            }
          }
        }
      }
    }
  }

  .bg-line {
    position: absolute;
    left: 0;
    top: 170px;
    opacity: .3;
    @media only screen and (max-width: 780px) {
      width: 50px;
    }
    @media only screen and (max-width: 580px) {
      top: 30px;
      width: 30px;
    }
  }

  .bg-hexa {
    position: absolute;
    right: 0;
    bottom: 0;
    @media only screen and (max-width: 780px) {
      width: 150px;
    }
  }
}

</style>